const en = {
  about: {
    name: "Ulises Lugo",
    subtitle: "Web Developer",
    description: "I am passionate about creating functional and attractive digital solutions. With extensive knowledge in Python, React, PHP, PostgreSQL, and CSS, and experience in web application development, scripts, and information systems. I enjoy working on both large and small projects, always seeking to improve my skills and knowledge.",
    downloadCV: "Download CV"
  },
  banner: {
    title: "Ulises Lugo",
    subtitle: "Web Developer"
  },
  skills: {
    title: "Skills and Studies",
    studies: "Studies",
    universityCareer: "University Career",
    universityName: "Gran Mariscal de Ayacucho",
    graduationDegree: "Computer Engineer",
    coursesTitle: "Courses Completed and Recognitions",
    viewCourses: "View Courses",
    languages: "Languages",
    programming: "Programming",
    design: "Design",
    tools: "Tools",
    knowledge: "Knowledge",
    studiesCourses: [
      "Introduction to Cybersecurity (Cisco)",
      "Cybersecurity Essentials (Cisco)",
      "Packet Tracer (Cisco)",
      "Python Essentials 1.1 (Cisco)",
      "Participation (2nd place) Programming Tournament 2024-1 UGMA",
      "Basic English 2nd semester at CEBA-UCV",
      "Technical Report Writing (INCES)",
      "Basic Supervision (INCES)",
      "Emotional Intelligence (PDVSA GAS)"
    ],
    languagesList: [
      { skill: "Spanish", level: 10 },
      { skill: "English", level: 7 }
    ],

    toolsList: [
      "Git + GitHub",
      "Command Console",
      "AI Tools",
      "Visual Studio Code",
      "Packet Tracer",
      "Unity"
    ],
    knowledgeList: [
      "Algorithm and Data Structure Design",
      "User Interface Design",
      "Relational Databases",
      "Network Design",
      "Agile Software Development"
    ]
  },
  projects: {
    title: "My Projects",
    developedIn: "Developed in"
  },
  whatIDo: {
    title: "What I Do",
    intro: "I specialize in creating intuitive and efficient digital solutions across multiple domains.",
    frontendTitle: "Front-End Development",
    frontendDesc: "Building responsive, performant web interfaces using React, JavaScript, and modern tools.",
    designTitle: "Interface & Component Design",
    designDesc: "Designing user-friendly interfaces and reusable components for seamless user experiences.",
    scriptingTitle: "Scripting & Automation",
    scriptingDesc: "Creating scripts and automation tools to streamline workflows and data processing.",
    infoSystemsTitle: "Information Systems",
    infoSystemsDesc: "Developing robust backend systems and databases to manage and secure data effectively."
  }
};

export default en;
